module.exports = __webpack_public_path__ + "static/img/certificate_img28.7d7350b5.jpg";